/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_TitleInputs */

const tr_landing_community_title = /** @type {(inputs: Landing_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnız değilsiniz.`)
};

const en_landing_community_title = /** @type {(inputs: Landing_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're not alone.`)
};

const de_landing_community_title = /** @type {(inputs: Landing_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind nicht allein.`)
};

const ru_landing_community_title = /** @type {(inputs: Landing_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы не одни.`)
};

/**
* | output |
* | --- |
* | "You're not alone." |
*
* @param {Landing_Community_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_title = /** @type {((inputs?: Landing_Community_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_title(inputs)
	if (locale === "de") return de_landing_community_title(inputs)
	if (locale === "ru") return ru_landing_community_title(inputs)
	return tr_landing_community_title(inputs)
});